// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function zambiaOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'zm',
    phone_number: userInputValues['zambiaPhoneNumber'],
  };
}
